// extracted by mini-css-extract-plugin
export default {"title":"toast_title__0pNQo"};